module.exports = __webpack_public_path__ + "img/standequip.8b40000b.svg";